<template>
  <base-form
    v-model="data"
    :options="options"
    :disabled="disabled"
    labelWidth="100px"
    ref="form"
  ></base-form>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  import AGENCY_API from '@/api/agencyContract/index';
  import { dateFormat } from '@/filters/index';
  export default {
    props: {
      defaultData: {
        type: Object,
        default: () => {},
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      baseForm,
    },
    data() {
      return {
        data: {},
      };
    },
    computed: {
      options() {
        return [
          {
            type: 'date',
            label: this.$t('businessReceiptList.table.inboundDate'),
            prop: 'inboundDate',
            required: true,
          },
          {
            type: 'select', // 入库类型：来源于供应商
            label: this.$t('businessReceiptList.create.storageType'),
            prop: 'inboundType',
            disabled: true,
            required: true,
            options: [
              {
                value: '0',
                label: this.$t('supplierDeliveryOrder.search.isDirectDeliverOptionTwo'),
              },
              {
                value: '1',
                label: this.$t('supplierDeliveryOrder.search.isDirectDeliverOptionOne'),
              },
            ],
          },
          {
            type: 'input',
            label: this.$t('businessReceiptList.search.supplier'),
            prop: 'partnerName',
            disabled: true,
            required: true,
          },
          {
            type: 'input',
            label: this.$t('businessReceiptList.search.salesman'),
            prop: 'salesmanPersonName',
            disabled: true,
            required: true,
          },
          {
            type: 'input',
            label: this.$t('businessReceiptList.search.department'),
            prop: 'inboundDepartmentName',
            disabled: true,
            required: true,
          },
          {
            type: 'input',
            label: this.$t('businessReceiptList.search.warehouse'),
            prop: 'storageName',
            disabled: true,
            required: true,
          },
          {
            type: 'ajaxSelect', // 业务性质字典查询确认
            label: this.$t('businessReceiptList.create.businessType'),
            prop: 'businessProperty',
            apiData: { dictType: 'purchase_business_type' },
            apiUrl: AGENCY_API.DICT_LIST,
            disabled: true,
            required: true,
          },
          {
            type: 'ajaxSelect', // 币种
            label: this.$t('businessReceiptList.create.currency'),
            prop: 'currencyTypeCode',
            disabled: true,
            apiUrl: AGENCY_API.LIST_CURRENCY,
            method: 'get',
            apiData: { isEnabled: 1 },
            required: true,
            name: 'currencyTypeName',
            code: 'currencyTypeCode',
            valueKey: 'currencyCode',
            moreShowKey: 'currencyCode',
            labelKey: 'currencyName',
            valueType: 'object',
          },
          {
            type: 'input',
            label: this.$t('contractAgency.rateLabel'),
            prop: 'exchangeRate',
            disabled: true,
          },
          {
            type: 'ajaxSelect', // 贸易类型
            label: this.$t('businessReceiptList.search.tradeType'),
            prop: 'tradeType',
            apiData: { dictType: 'purchase-trade-type' },
            apiUrl: AGENCY_API.DICT_LIST,
            disabled: true,
            required: true,
          },
        ];
      },
    },
    watch: {
      defaultData() {
        this.setData();
      },
      'defaultData.storageName': {
        handler(newName) {
          this.data.storageName = newName;
        },
        immediate: true,
        deep: true,
      },
      'defaultData.exchangeRate': {
        handler(newName) {
          this.data.exchangeRate = newName;
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.setData();
    },
    methods: {
      setData() {
        const data = Object.assign(
          {
            inboundDate: dateFormat(new Date()),
          },
          this.data,
          this.defaultData
        );
        this.data = data;
      },
      // 获取数据
      getValues() {
        const data = this.data;
        const result = Object.assign({}, data, {});
        return result;
      },
      handleSubmit() {
        return this.$refs['form'].handleSubmit();
      },
    },
  };
</script>
